export default __webpack_public_path__ + "static/media/632.99f6b728.gif";